import { Outlet, Route } from "react-router-dom";
import { ShowProvider } from "../../../providers";
import { SegmentsList } from "../../PushNotification/Segments/Segments-List";
import { SegmentUsersPage } from "../Users/SegmentUsersPage";

const segmentsRoutes = [
  <Route key={"segments-root"} path="segments" element={<Outlet />}>
    <Route
      index
      element={
        <ShowProvider>
          <SegmentsList />
        </ShowProvider>
      }
    />
    <Route
      path=":segmentId"
      element={
        <ShowProvider>
          <SegmentUsersPage />
        </ShowProvider>
      }
    />
  </Route>,
];

export const SEGMENTS_ROUTES = segmentsRoutes.map((route) => route);
